import type { PagesDto } from '@octopus-do/octopus-api-client'
import type React from 'react'

import { SectionTitles } from '../../constants'
import type { SectionType, SortType } from '../../types'
import { LoadMoreButton, PagesHeader, PagesList } from './components'
import css from './styles.module.css'

interface Props {
  activeSection: SectionType
  changes: boolean
  hasMore: boolean
  items: PagesDto['items']
  loading: boolean
  loadingMore: boolean
  onLoadMore: () => void
  onSearchChange: (value: string) => void
  onSortChange: (value: SortType) => void
  search: string
  sort: SortType
}

export const PagesSection: React.FC<Props> = ({
  activeSection,
  changes,
  hasMore,
  items,
  loading,
  loadingMore,
  onLoadMore,
  onSearchChange,
  onSortChange,
  search,
  sort,
}) => {
  const title = changes
    ? `${SectionTitles[activeSection]} changes`
    : SectionTitles[activeSection]

  // A search that finds nothing is a different answer from a section that is
  // empty, and saying so is what tells the user the box is doing anything.
  const emptyByFilter = changes
    ? 'Nothing changed here since the previous crawl.'
    : 'No pages in this section.'
  const empty = search ? `No pages match "${search}".` : emptyByFilter

  return (
    <div>
      <PagesHeader
        title={title}
        activeSection={activeSection}
        onSearchChange={onSearchChange}
        onSortChange={onSortChange}
        search={search}
        sort={sort}
      />

      {!loading && !items.length && <div className={css.empty}>{empty}</div>}

      <PagesList items={items} />

      {hasMore && <LoadMoreButton loading={loadingMore} onClick={onLoadMore} />}
    </div>
  )
}
